module.exports = __webpack_public_path__ + "static/media/hops_vines.b851e4db.jpeg";